const getSeeksColumns = () => {
  return [
    {
      title: 'S.No',
      dataIndex: 'id',
      render: (text, record, index) => index + 1,
      sorter: (a, b) => a.id.length - b.id.length,

      width: '10%'
    },
    {
      title: 'Name',
      render: (text, record) => (
        <span>
          {record.firstName
            ? `${record.firstName} ${record.lastName || ''}`
            : ''}
        </span>
      ),
      sorter: (a, b) => {
        const nameA = `${a.firstName}  ${a.lastName || ''}`.toLowerCase()
        const nameB = `${b.firstName}  ${b.lastName || ''}`.toLowerCase()
        return nameA.length - nameB.length
      },
      width: '25%'
    },
    {
      title: 'Email',
      dataIndex: 'email',
      width: '25%'
    },
    {
      title: 'Role',
      dataIndex: 'role',
      width: '25%'
    },

    {
      title: 'GMO-Id',
      dataIndex: 'gmoId',
      width: '25%'
    },
    
  ]
}

export default getSeeksColumns
